// extracted by mini-css-extract-plugin
export var eventGroup = "EventGroup-module--eventGroup--a662b";
export var legGroup = "EventGroup-module--legGroup--f332d";
export var legGroupDeactivated = "EventGroup-module--legGroupDeactivated--75a3b";